/*
 * This file is part of the Convergence API Server.
 *
 * (c) Convergence <https://convergence.finance/>
 */

import gql from "graphql-tag";
import { DOCUMENT_FRAGMENT } from "./DocumentQuery";

export const DESIGN_FUNDING_APPLICATION_FRAGMENT = gql`
    fragment generatelDesignFundingApplicationFields on DesignFundingApplication {
        id
        status
        name
        institution_name
        vehicle_name
        solution_description
        countries
        focus_areas
        is_blended_finance_transaction
        funding_window
        name
        email_address
        vehicle_name
        design_activity
        can_share_proposal
        is_compliant
    }
`;

export const GET_DESIGN_FUNDING_APPLICATION = gql`
    query GetDesignFundingApplication(
        $email_address: Email!
        $access_code: Int!
    ) {
        getDesignFundingApplication(
            email_address: $email_address
            access_code: $access_code
        ) {
            ...generatelDesignFundingApplicationFields
            documents {
                ...generalDocumentFields
            }
        }
    }
    ${DESIGN_FUNDING_APPLICATION_FRAGMENT}
    ${DOCUMENT_FRAGMENT}
`;
